// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../assets/Images/Presentation-elements-06 (4).png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../assets/Images/Icon-01.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidemenu
  .mui-1f773le-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
  height: 35px;
  min-height: 35px;
}
.sidemenu .mui-1f773le-MuiButtonBase-root-MuiAccordionSummary-root {
  height: 35px;
  min-height: 35px;
}
.sidemenu .nav-link {
  color: lightgray;
}
.sidemenu .active {
  font-weight: 500 !important;
  color: white;
}
.sidemenu {
  font-family: "Inter" !important;
}
.sidemenu ::marker {
  color: white;
}
.menu .mui-1e6y48t-MuiButtonBase-root-MuiButton-root:hover {
  background-color: #003462;
}
.menu .icon {
  width: 45px !important;
  height: 45px !important;
  min-width: 45px !important;
  background-color: #003462;
  border-color: #003462;
  border: 1px solid #003462;
  text-decoration: none;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 1rem !important;
  letter-spacing: 1px;
  margin-inline-start: 10px;
}
.sidemenu ::-webkit-scrollbar {
  width: 6px;
  border-radius: 5px;
}
/* Track */
.sidemenu ::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
.sidemenu ::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}
/* Handle on hover */
.sidemenu ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.sidemenu .mui-1086bdv-MuiPaper-root-MuiAccordion-root::before {
  display: none;
}
.mui-1086bdv-MuiPaper-root-MuiAccordion-root.Mui-expanded {
  margin: 0 !important;
}

.sidemenu .expanded {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-size: 80%;
  /* height: 80px; */
  background-repeat: no-repeat;
}
.sidemenu .collapsed {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-size: 100%;
  background-repeat: no-repeat;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SideMenu/SideMenu.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;AACA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,yDAAkF;EAClF,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,yDAA0D;EAC1D,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":[".sidemenu\n  .mui-1f773le-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {\n  height: 35px;\n  min-height: 35px;\n}\n.sidemenu .mui-1f773le-MuiButtonBase-root-MuiAccordionSummary-root {\n  height: 35px;\n  min-height: 35px;\n}\n.sidemenu .nav-link {\n  color: lightgray;\n}\n.sidemenu .active {\n  font-weight: 500 !important;\n  color: white;\n}\n.sidemenu {\n  font-family: \"Inter\" !important;\n}\n.sidemenu ::marker {\n  color: white;\n}\n.menu .mui-1e6y48t-MuiButtonBase-root-MuiButton-root:hover {\n  background-color: #003462;\n}\n.menu .icon {\n  width: 45px !important;\n  height: 45px !important;\n  min-width: 45px !important;\n  background-color: #003462;\n  border-color: #003462;\n  border: 1px solid #003462;\n  text-decoration: none;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  font-size: 1rem !important;\n  letter-spacing: 1px;\n  margin-inline-start: 10px;\n}\n.sidemenu ::-webkit-scrollbar {\n  width: 6px;\n  border-radius: 5px;\n}\n/* Track */\n.sidemenu ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n/* Handle */\n.sidemenu ::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n/* Handle on hover */\n.sidemenu ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.sidemenu .mui-1086bdv-MuiPaper-root-MuiAccordion-root::before {\n  display: none;\n}\n.mui-1086bdv-MuiPaper-root-MuiAccordion-root.Mui-expanded {\n  margin: 0 !important;\n}\n\n.sidemenu .expanded {\n  background-image: url(\"./../../assets/Images/Presentation-elements-06\\ \\(4\\).png\");\n  background-position: center center;\n  background-size: 80%;\n  /* height: 80px; */\n  background-repeat: no-repeat;\n}\n.sidemenu .collapsed {\n  background-image: url(\"./../../assets/Images/Icon-01.png\");\n  background-position: center center;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
